import { ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "~/lib/utils";

export interface StatusMessageProps {
  title: string;
  body?: string;
  icon?: ReactNode;
  // Extra classes for the outer container so callers can control how the
  // message fills its slot (full page, panel, inline).
  className?: string;
}

/**
 * Centered icon + title + body block for empty/error states across nextgen.
 * Presentational only — callers supply the copy. Renders `role="alert"` so
 * assistive tech announces load failures.
 */
export const StatusMessage = ({ title, body, icon, className }: StatusMessageProps) => (
  <div
    role="alert"
    className={cn(
      "flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center text-muted-foreground",
      className
    )}
  >
    {icon ?? <AlertCircle className="size-8" aria-hidden="true" />}
    <p className="text-sm font-medium text-foreground">{title}</p>
    {body && <p className="text-sm">{body}</p>}
  </div>
);
